export default {
  // Active brand — change this to switch the entire build (favicons, colors, logo, legal name).
  // Valid values: 'tradicional' | 'bravo'
  brand: 'tradicional',

  path: '',

  // api: 'http://localhost:3004/', // LOCAL
  api: 'https://vxutyq1o5h.execute-api.us-east-1.amazonaws.com/v1/ws-afiliados/', // TRAD PRD
  // api: 'https://toa911souj.execute-api.us-east-1.amazonaws.com/DEV/ws-gestao/', // LOCAL
  // api: 'https://jjst6rxnnf.execute-api.us-east-1.amazonaws.com/', // DEV TRD
  urlAWS: '',

  keyPair: '',
  apiViaCep: 'https://viacep.com.br/ws/',
  apiBankList: 'https://brasilapi.com.br/api/banks/v1',
}            
